import { call, select } from 'redux-saga-test-plan/matchers';
import { put } from 'redux-saga/effects';

import { AccountApi } from '@shared/api/auth-api';
import { LogoutReason } from '@shared/constants';
import { HttpStatusCodes } from '@shared/constants/httpStatusCodes';
import { LOGOUT_FAILURE, logoutSuccess } from '@shared/redux/actions/auth-actions';
import { ActionWithPayload } from '@shared/redux/actions/typings';
import { RootState } from '@shared/redux/state/root';
import { handleSagaError } from '@shared/util/handleSagaError';

export interface LogoutRequestPayload {
  reason?: LogoutReason;
}

export function* fetchLogoutRequest(action: ActionWithPayload<LogoutRequestPayload>) {
  try {
    const isAuthorized: boolean = yield select((state: RootState) => state.auth.isAuthenticated);
    if (!isAuthorized) {
      return;
    }

    const reason = action?.payload?.reason ?? LogoutReason.Unknown;
    try {
      if (reason !== LogoutReason.TokenRefreshFailed) {
        yield call(AccountApi.logout, reason);
      }
    } catch (e: any) {
      // there is no error if we do logout and user is not authorized.
      if (e?.request?.status !== HttpStatusCodes.Unauthorized) {
        throw e;
      }
    }

    yield put(logoutSuccess(reason));
  } catch (e) {
    yield handleSagaError({
      type: LOGOUT_FAILURE,
      error: e,
    });
  }
}
